module.exports = __webpack_public_path__ + "static/media/addicon.a0655a77.svg";